var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarChartSharp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "ionicon",
    viewBox: "0 0 512 512",
    style: {
      fill: "#a7b1c2"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 496H16V16h32v448h448v32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192 432H80V208h112zM336 432H224V160h112zM479.64 432h-112V96h112z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChartSharp);
export default __webpack_public_path__ + "static/media/bar-chart-sharp.8ad644c64740b8eb91b07cd7afea5dab.svg";
export { ForwardRef as ReactComponent };